"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LimitCard_1 = __importDefault(require("../LimitCard"));
var next_intl_1 = require("next-intl");
var types_1 = require("../../types");
var swr_hooks_1 = require("@l2p/swr-hooks");
var DepositLimit = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, swr_hooks_1.useSessionLimit)(), data = _a.data, isLoading = _a.isLoading, isValidating = _a.isValidating;
    if (isLoading || isValidating)
        return null;
    return (react_1.default.createElement(LimitCard_1.default, { title: t('sessionTimeLimit'), description: t('sessionTimeLimitDescription'), type: types_1.LimitType.SESSION, data: data }));
};
exports.default = DepositLimit;
